import React, { useEffect, useRef, useState } from "react";
import "./Indicators.scss";

const Indicators = () => {
    const stats = [
        { value: 7, suffix: "Y", label: "Working on Products" },
        { value: 12, suffix: "", label: "Happy Clients" },
        { value: 14, suffix: "", label: "Quality Deliveries" },
    ];

    const [visible, setVisible] = useState(false);
    const [counts, setCounts] = useState(stats.map(() => 0));
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.unobserve(sectionRef.current);
                }
            },
            { threshold: 0.3 }
        );

        if (sectionRef.current) observer.observe(sectionRef.current);
        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        if (!visible) return;

        const duration = 1500;
        const startTime = performance.now();

        const animate = (time) => {
            const progress = Math.min((time - startTime) / duration, 1);
            setCounts(stats.map((s) => Math.floor(progress * s.value)));

            if (progress < 1) requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
    }, [visible]);

    return (
        <section className="indicators" ref={sectionRef}>
            <div className="indicators-container">
                <h2 className="indicators-title">
                    Our Track Record in Numbers
                </h2>

                <div className="indicator-stats">
                    {stats.map((s, i) => (
                        <div key={i} className={`indicator ${visible ? "visible" : ""}`}>
                            <h3 className="gradient-text">
                                {counts[i]}
                                {s.suffix}
                            </h3>
                            <p>{s.label}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Indicators;
